import React, { Component } from "react";
import Footer from "../components/footer.component";
import Header from "../components/header.component";
import "../css/page.css";
import reportVisitService from "../reporting-visit/report-visit.service";

export default class AboutMePage extends Component {
  componentDidMount() {
    document.title =
      "Something about me | David Šimák - A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }
  render() {
    return (
      <div>
        <Header lightColor={true} />
        <div className="page_title_container">
          <label class="big_title">Something about me</label>
        </div>

        <div class="section">
          <p>
            I am a self-taught Java/Kotlin developer from Zlín, Czech Republic,
            with passion for developing innovative digital products. My main{" "}
            specialization is developing APIs and Android applications.
            <br />
            <br />
            My programming journey started in 2015 when I was studying{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.spszl.cz/"
            >
              <b>Technical Lyceum on high school in Zlín</b>
            </a>
            . The language I chose at the time was <b>Java</b>, because I wanted
            create applications for my Android phone and also shared them to the
            world through Google Play. Later I wanted to create web applications
            so I expanded my skills with HTML, CSS and JavaScript. Because I
            wanted to create more complex web applications, I learned{" "}
            <b>JSF (JavaServer Faces)</b>. But because it was not suitable for
            me and my needs, I was searching for new technologies and came
            across <b>Spring frameworks</b> and start developing APIs in{" "}
            <b>Spring Boot</b>. For the frontend I choose <b>ReactJS</b>. These
            technologies I am using for building websites and Rest APIs to this
            day.
            <br />
            <br />
            In 2017 I started two week internship in{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://elisoft.cz/"
            >
              <b>Elisoft s.r.o.</b>
            </a>{" "}
            where I then worked part-time while studying high school. After
            graduating from high school, I worked here for almost 5 years as an
            Android developer on several projects and later also worked there
            with cloud functions and authentication in Google Firebase and try
            docker with kubernetes. From May 2022 I am working as Java/Kotlin
            developer in{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.papirfly.com/"
            >
              <b>Papirfly</b>
            </a>{" "}
            where I am developing innovative marketing tools and tools for
            effective brand management that are used by big companies like
            Subway, Coca-Cola, Fjällräven, Helly Hansen, Bridgestone and more
            then 500 others world companies.
            <br />
            <br />
            When I am not coding I either go hiking with my girlfriend and dogs,
            cooking, watching films and serials, listening music or play logic
            games such as chess and sudoku.
            <br />
            <br />
            <b>Other things</b>
            <br />
            <ul>
              <li>Fan of Open Source Software, Android, Linux</li>
              <li>
                {" "}
                Daily drive Fedora 36 on laptop and Debian 11 on his servers
              </li>
              <li> Prefer laptop over desktop computer</li>
              <li> Likes tea and pizza</li>
              <li>
                Big fan of Marvel, Star Wars, Star Trek, Star Gate and
                Battlestar Galactica
              </li>
            </ul>
          </p>
        </div>
        <hr
          style={{
            backgroundColor: "#BDBDBD",
            height: "1px",
            border: "0px",
            opacity: 1,
          }}
        />
        <div class="section">
          <h1 className="section-title">Technologies I use</h1>
          <hr className="section-title-hr" />
          <br />
          <p>
            <h3>Android development</h3>
            JAVA 11, Room/SQLite, Gradle, Android Studio, HttpComponents, ACRA,
            Firebase, Crashlytics
            <br />
            <br />
            <br />
            <h3>Frontend development</h3>
            ReactJS, Javascript, HTML, CSS, VS Codium, NPM, Axios, Cookies
            <br />
            <br />
            <br />
            <h3>Backend development</h3>
            JAVA 17, Kotlin, Spring Boot Framework, PostgreSQL, Postman,
            IntelliJ IDEA, VS Codium, MAVEN, Log4j2
            <br />
            <br />
            <br />
            <h3>Infrastructure</h3>
            Debian Server, Kubernetes, k3s, Docker Container
            <br />
            <br />
            <br />
            <h3>Other</h3>
            Gitlab, Terminal, XML, JSON, AES-256, Firebase, Firestore, Google
            Cloud Functions
            <br />
            <br />
            <br />
            <h3>Technologies I want to learn</h3>
            OpenFaas, Spring Native
            <br />
            <br />
            <br />
            <h3>Technologies I am currently learning</h3>
            Kotlin, AWS
            <br />
            <br />
            <br />
            <h3>Other technologies I know, but not currently use</h3>
            Glassfish, JavaServer Faces, SQLite, MongoDB, Microk8s, Wordpress
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}
